import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import VueRouter from "vue-router";
import store from "./store";

import PageGuest from "./components/PageGuest.vue";
import PageAuth from "./components/PageAuth.vue";

import PageError from "./views/error/Page.vue";
import PageDashboard from "./views/dashboard/Page.vue";
import PageLogin from "./views/login/Page.vue";
import PageBarcode from "./views/barcode/Page.vue";
import PageBoxcode from "./views/boxcode/Page.vue";
import PageBoxbind from "./views/boxbind/Page.vue";
import PageBuildlog from "./views/buildlog/Page.vue";
import PageInventory from "./views/inventory/Page.vue";
import PageInfo from "./views/boxinfo/Page.vue";
import PageProduct from "./views/product/Page.vue";
import PageTrace from "./views/trace/Page.vue";
import PageWarein from "./views/warein/Page.vue";
import PageWareout from "./views/wareout/Page.vue";
import PageWareorder from "./views/wareorder/Page.vue";
import PagePeople from "./views/people/Page.vue";

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueLocalStorage);
Vue.use(VueRouter);

const checkIsLogin = () => {
  const session = Vue.localStorage.get("token")
  return !!session;
}

const router = new VueRouter({
  mode: "hash",
  routes: [
    {
      path: '/',
      redirect: '/web/dashboard'
    },
    {
      path: "/web",
      component: PageGuest,
      children: [
        {
          path: 'login',
          meta: {title: "账号登录"},
          component: PageLogin,
        },
      ]
    },
    {
      path: "/web",
      component: PageAuth,
      children: [
        {
          path: 'dashboard',
          meta: {title: "系统主页"},
          component: PageDashboard,
        },
        {
          path: 'buildlog',
          meta: {title: "生码记录"},
          component: PageBuildlog,
        },
        {
          path: 'barcode',
          meta: {title: "条码管理"},
          component: PageBarcode,
        },
        {
          path: 'boxcode',
          meta: {title: "箱码管理"},
          component: PageBoxcode,
        },
        {
          path: 'warein',
          meta: {title: "入库记录"},
          component: PageWarein,
        },
        {
          path: 'wareout',
          meta: {title: "出库记录"},
          component: PageWareout,
        },
        {
          path: 'boxbind',
          meta: {title: "箱码绑定"},
          component: PageBoxbind,
        },
        {
          path: 'inventory',
          meta: {title: "库存查询"},
          component: PageInventory,
        },
        {
          path: 'boxinfo',
          meta: {title: "绑箱查询"},
          component: PageInfo,
        },
        {
          path: 'trace',
          meta: {title: "条码朔源"},
          component: PageTrace,
        },
        {
          path: 'product',
          meta: {title: "产品管理"},
          component: PageProduct,
        },
        {
          path: 'wareorder',
          meta: {title: "订单管理"},
          component: PageWareorder,
        },
        {
          path: 'people',
          meta: {title: "人员管理"},
          component: PagePeople,
        },
      ]
    },
    {
      path: '*',
      meta: {title: "404"},
      component: PageError,
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  const path = to.path;
  const pathInfo = path.split('/');
  const page = pathInfo.slice(0, 3).join('/');

  store.commit("updateCurrentPage", {
    title: to.meta.title,
    url: page,
  });
  const loginPage = '/web/login';
  if (to.path === loginPage) {
    next()
  } else {
    if (checkIsLogin()) {
      next()
    } else {
      next({path: loginPage, replace: true})
    }
  }
});

export default router;
